import "babel-polyfill";
import Vue from 'vue';
import ElementUI from 'element-ui';

import 'element-ui/lib/theme-chalk/index.css';
import '../public/common.css';
import '../public/publicStyle.scss';
import App from './App.vue';
import VueBus from "vue-bus";
import SlideVerify from '../node_modules/vue-monoplasty-slide-verify';
import "./assets/fonts/lay/iconfont.css";
import "./assets/fonts/color/iconfont.css";
import "./assets/fonts/flow/iconfont.css";
import "./assets/fonts/chart/iconfont.css";
import './utils/directive';
Vue.config.productionTip = false;
import router from './router'
import store from './store'
import getSocket from './websocket/websocket'
import i18n from './locales/i18n.js'
import * as filters from "./filters"   //新增过滤器
import * as math from 'mathjs'
import {DateTime} from 'luxon'
import removeAria from "./components/removeAria";
import setPrecision from './components/setPrecision';
import './registerServiceWorker'
// import  VueI18n  from "vue-i18n"
import en_us from "./locales/en_us.json"; // 英文
import zh_cn from "./locales/zh_cn.json"; // 中文
import vi_vn from "./locales/vi_vn.json"; // 越南文
// console.log(i18n,'i18n')
// console.log(i18n,'i18n')
// Vue.use(VueI18n);

Vue.use(SlideVerify);
Vue.use(ElementUI,{
  i18n:(key,value)=>i18n.t(key,value)
});
Vue.use(VueBus);
Vue.directive('removeAria',removeAria);
Vue.config.productionTip = false;

Vue.prototype.$math = math;
Vue.prototype.$getSocket = getSocket;
Vue.prototype.$DateTime = DateTime;//日期处理器
Vue.prototype.$setPrecision = setPrecision;//精度设置


//全局方法 element 校验表单
Vue.prototype.$formRulesValidate = ({ ref, example }) => {
  return new Promise((res) => {
    example.$refs[ref].validate((valid)=>{
      res(valid);
    });
  });
};

// register global utility filters 注册全局过滤 此处是新添加内容002
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

new Vue({
  router,i18n,
  store,
  data:function(){
    return {
      workSize:{h:0,w:0},
    }
  },
  render: h => h(App)
}).$mount('#app');

